/**
 * The applicant emails, by key, with the name staff see (Settings → Applicant
 * emails, the activity trail, approve/decline messages). The wording itself
 * lives in the API's mailer.
 */
export const EMAIL_TEMPLATE_NAMES = {
  trade_approved: 'Trade account approved',
  trade_declined: 'Trade application declined',
  credit_review: 'Credit application under review',
  credit_application_declined: 'Credit application declined',
  credit_approved: 'Credit account approved',
  credit_declined: 'Credit terms declined',
  supplier_approved: 'Supplier account set up',
  supplier_declined: 'Supplier application declined',
  lead_confirm: 'Enquiry received',
} as const;

export type EmailTemplateKey = keyof typeof EMAIL_TEMPLATE_NAMES;

/**
 * The emails an approve and a decline send at a stage (F10). The approval
 * email for a new account only goes once iQ has accepted the record.
 */
export function decisionEmailKeys(
  formType: string,
  stage: 'cs' | 'accounts' | 'supplier',
): { approve: EmailTemplateKey; decline: EmailTemplateKey } {
  if (stage === 'accounts') return { approve: 'credit_approved', decline: 'credit_declined' };
  if (stage === 'supplier' || formType === 'supplier_account') {
    return { approve: 'supplier_approved', decline: 'supplier_declined' };
  }
  if (formType === 'credit_account') return { approve: 'credit_review', decline: 'credit_application_declined' };
  return { approve: 'trade_approved', decline: 'trade_declined' };
}

/** The emails JFH Forms never sends yet (their switch can't be turned on). */
export const UNSENT_EMAILS: readonly EmailTemplateKey[] = ['lead_confirm'];

/** Settings → Applicant emails, grouped by the applicant's journey (F10 P5). */
export const EMAIL_JOURNEYS: { label: string; keys: EmailTemplateKey[] }[] = [
  { label: 'Trade account', keys: ['trade_approved', 'trade_declined'] },
  { label: 'Credit account', keys: ['credit_review', 'credit_application_declined', 'credit_approved', 'credit_declined'] },
  { label: 'Supplier account', keys: ['supplier_approved', 'supplier_declined'] },
  { label: 'Website enquiry', keys: ['lead_confirm'] },
];
